import api from './api';

const boutiqueService = {
  // Récupérer toutes les boutiques
  getBoutiques: async (params = {}) => {
    try {
      const response = await api.get('/boutiques', { params });
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des boutiques:', error);
      throw error;
    }
  },

  // Récupérer une boutique par ID
  getBoutique: async (id) => {
    try {
      const response = await api.get(`/boutiques/${id}`);
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération de la boutique:', error);
      throw error;
    }
  },

  // Rechercher des boutiques
  searchBoutiques: async (query) => {
    try {
      const response = await api.get('/boutiques', {
        params: { search: query }
      });
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la recherche des boutiques:', error);
      throw error;
    }
  },

  // Récupérer les produits d'une boutique (route publique - seulement les produits actifs)
  getBoutiqueProducts: async (boutiqueId) => {
    try {
      // Utiliser la route publique /products avec le paramètre boutiqueId
      // Par défaut, cette route retourne seulement les produits actifs (isActive: true)
      const response = await api.get('/products', {
        params: { boutiqueId, isActive: true }
      });
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des produits de la boutique:', error);
      throw error;
    }
  },

  // Créer une boutique
  createBoutique: async (boutiqueData, logoFile = null) => {
    try {
      const formData = new FormData();
      
      // Ajouter tous les champs du formulaire
      Object.keys(boutiqueData).forEach(key => {
        if (key !== 'logo') { // Ne pas inclure logo dans FormData si c'est une URL
          const value = boutiqueData[key];
          if (value !== null && value !== undefined) {
            if (Array.isArray(value)) {
              formData.append(key, JSON.stringify(value));
            } else {
              formData.append(key, value);
            }
          }
        }
      });
      
      // Ajouter le fichier logo s'il existe
      if (logoFile) {
        formData.append('logo', logoFile);
      }
      
      const response = await api.post('/boutiques', formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la création de la boutique:', error);
      throw error;
    }
  },

  // Mettre à jour une boutique
  updateBoutique: async (id, boutiqueData, logoFile = null) => {
    try {
      const formData = new FormData();
      
      // Ajouter tous les champs du formulaire
      Object.keys(boutiqueData).forEach(key => {
        if (key !== 'logo') { // Ne pas inclure logo dans FormData si c'est une URL
          const value = boutiqueData[key];
          if (value !== null && value !== undefined) {
            if (Array.isArray(value)) {
              formData.append(key, JSON.stringify(value));
            } else {
              formData.append(key, value);
            }
          }
        }
      });
      
      // Ajouter le fichier logo s'il existe
      if (logoFile) {
        formData.append('logo', logoFile);
      } else if (boutiqueData.logo === '' || boutiqueData.logo === null) {
        // Si logo est explicitement vide, envoyer une chaîne vide pour supprimer le logo
        formData.append('logo', '');
      }
      
      const response = await api.put(`/boutiques/${id}`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la mise à jour de la boutique:', error);
      throw error;
    }
  },

  // Supprimer une boutique
  deleteBoutique: async (id) => {
    try {
      const response = await api.delete(`/boutiques/${id}`);
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la suppression de la boutique:', error);
      throw error;
    }
  }
};

export default boutiqueService;
